module.exports = __webpack_public_path__ + "img/service-datacenter.f6f1227c.jpg";